module.exports = __webpack_public_path__ + "img/home.1d0c64e8.svg";